import useTimeZoneClock from 'hooks/useTimeZoneClock';
import React from 'react'
import { Table } from 'reactstrap'

const LogsTable = ({ logs }) => {
    // const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');
    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-3">
                    <span>Date</span>
                </th>
                <th className="col-3">
                    Time
                </th>
                <th className="col-3">
                    Event
                </th>
                {/* <th className="col-2">
                    User
                </th> */}
                <th className="col-3">
                    Notes
                </th>
            </tr>
        )
    }, [])


    const renderTableContent = React.useCallback((item) => {
        return (
            <LogItem item={item} key={item?.id} />
        )
    }, []);

    return (
        <div className='table_responsive'>
            <table className="table">
                <thead className="text-primary">
                    {renderTableHeader()}
                </thead>
                <tbody>
                    {
                        logs && logs?.map(item => renderTableContent(item))
                    }
                </tbody>
            </table>
        </div>
    )
}

const LogItem = ({ item }) => {



    // const timeZone = useTimeZoneClock(item?.datetime);

    return (

        <tr>
            <td className='col-3'>
                {item?.date ? new Date(item.date).toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric'
                }) : 'N/A'}
            </td>
            <td className='col-3'>
                {item?.time}
            </td>
            <td className='col-3'>
                {item?.event}
            </td>
            {/* <td className='col-2'>
                {item?.user?.name}
            </td> */}
            <td className='col-3'>
                {item?.notes}
            </td>
        </tr>
    )
}
export default LogsTable